<template>
    <div class="wrap-tabs">
        <div class="wrap-tabs__content history" :class="{'mobile': $device.isMobileOrTablet}">
            <div v-if="!$device.isMobileOrTablet" class="table" :class="{'loading-data' : isLoading}">
                <div class="history__header">
                    <div>THỜI GIAN</div>
                    <div>GIẢI THƯỞNG</div>
                    <div>TRẠNG THÁI</div>
                </div>
                <div v-if="winnerBetHistory.length > 0" class="history__content">
                    <div v-for="(item, index) in winnerBetHistory" :key="index" class="history__item">
                        <div class="time"><span>{{item.datetime | formatDate('HH:mm | DD/MM/YYYY')}}</span></div>
                        <div>{{checkResult(item.result)}}</div>
                        <div>HOÀN THÀNH</div>
                    </div>
                </div>
                <div v-else class="history__content">
                    <div class="not-data text-center">
                        <img class="icon" :src="`${$store.state.mapDomain.STATIC_URL}/assets/img/event/worldcup/icon-empty.svg`" alt="empty">
                        <div class="top">LỊCH SỬ TRỐNG</div>
                        <div class="sub">Hệ thống sẽ cập nhật thông tin sớm nhất!</div>
                    </div>
                </div>
            </div>
            <div v-else class="table" :class="{'loading-data' : isLoading}">
                <div class="history__header">
                    <div>GIẢI THƯỞNG</div>
                    <div>TRẠNG THÁI/THỜI GIAN</div>
                </div>
                <div v-if="winnerBetHistory.length > 0 && !isLoading" class="history__content">
                    <div v-for="(item, index) in winnerBetHistory" :key="index" class="history__item">
                        <div>{{checkResult(item.result)}}</div>
                        <div class="content">
                            <span>Hoàn thành</span>
                            <div class="time">{{item.datetime | formatDate('HH:mm | DD/MM/YYYY')}}</div>
                        </div>
                    </div>
                    <div class="no-hover" v-if="isLoading">
                        <p class="pt-2 pb-1"></p>
                    </div>
                </div>
                <div v-else class="history__content">
                    <div class="not-data text-center">
                        <img class="icon" :src="`${$store.state.mapDomain.STATIC_URL}/assets/img/event/worldcup/icon-empty.svg`" alt="empty">
                        <div class="top">LỊCH SỬ TRỐNG</div>
                        <div class="sub">Hệ thống sẽ cập nhật thông tin sớm nhất!</div>
                    </div>
                </div>
            </div>
            <div class="history__pagination">
                <pagination
                        v-if="totalPage > 1"
                        :page="page"
                        :totalPage="totalPage"
                        :handlerPage="getUserHistoryWheel"
                ></pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
// eslint-disable-next-line import/no-unresolved
import Pagination from '~/components/pagination.vue';

export default {
    components: {
        Pagination
    },
    data() {
        return {
            isLoading: false,
            isSubmit: false
        };
    },
    computed: {
        currentUser() {
            return this.$store.state.user;
        },
        ...mapState('event/worldcup-wheel', {
            page: state => state.history.page,
            total: state => state.history.total,
            totalPage: state => state.history.totalPage,
            formData: state => state.history.formData,
            winnerBetHistory: state => state.history.winnerBetHistory
        })
    },
    methods: {
        async getUserHistoryWheel(page) {
            try {
                if (this.currentUser) {
                    if (this.isLoading) {
                        return;
                    }
                    this.isLoading = true;
                    await this.$store.dispatch('event/worldcup-wheel/getUserHistoryWheel', { page, username: this.currentUser ? this.currentUser.username : '' });
                    this.isLoading = false;
                    this.isSubmit = false;
                }
            } catch (error) {
                console.log(error);
                this.isSubmit = false;
                this.isLoading = false;
                this.$alertError('Server lỗi ! Vui lòng thử lại sau!');
            }
        },
        checkResult(item) {
            let $text = '';
            switch (item) {
                case 'match_win':
                    $text = '1 Trận thắng';
                    break;
                case 'match_lose':
                    $text = '1 Trận thua';
                    break;
                case 'match_draw':
                    $text = '1 Trận hòa';
                    break;
                case 'money_fifty':
                    $text = '50,000 VND';
                    break;
                case 'money_two_thousand':
                    $text = '2,000,000 VND';
                    break;
                case 'money_one_thousand':
                    $text = '1,000,000 VND';
                    break;
                case 'money_five_hundred':
                    $text = '500,000 VND';
                    break;
                case 'money_three_hundred':
                    $text = '300,000 VND';
                    break;
                case 'money_one_hundred':
                    $text = '100,000 VND';
                    break;
                case 'money_ten':
                    $text = '10,000 VND';
                    break;
                case 'super_return':
                    $text = 'Siêu hoàn trả';
                    break;
                default:
                    $text = 'Lucky';
                    break;
            }
            return $text;
        }
    },
    mounted() {
        this.$nextTick(async () => {
            await this.getUserHistoryWheel(1);
        });
    }
};
</script>
